/* import __COLOCATED_TEMPLATE__ from './checkbox.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./checkbox.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());